import { useRouter }       from "next/router";
import React, { useState } from "react";

import { storeCTEvent }                             from "_analytics/index";
import { useGetFeedbackModal, useSetFeedbackModal } from "_common/hooks/creator-dashboard/earn";
import Toast                                        from "_common/toast";
import { createURLSearchParams }                    from "_common/webview";
import {
	getPostMonitizationJourney,
	getLiveStreamMonitizationJourney
} from "_services/api/creator-dashboard";

import Presentation                           from "./presentation";
import { getMigratedInitialMonetisationData } from "./utils";

const updateMonetisationData = async type => {
	let callApi = ( type === "live" ) ? getLiveStreamMonitizationJourney : getPostMonitizationJourney;

	try {
		let response = await callApi ();

		return response;
	} catch ( e ) {
		Toast.e ( e.displayMsg );
	}

};

const component = props => {
	const { intialMonetisationData, isMigratingData, isMobile } = props;
	const [ activeTab, setActiveTab ]                           = useState ( "live" );
	const [ monetisationData, setMonetisationData ]             = useState ( isMigratingData ? getMigratedInitialMonetisationData ( { type: activeTab } ) : intialMonetisationData );
	const showFeedback                                          = useGetFeedbackModal ();
	const setShowFeedback                                       = useSetFeedbackModal ();
	const [ showStepperModal, setShowStepperModal ]             = useState ( false );

	const { isLiveStreamMonetised, isReelsMonetised } = monetisationData;

	const showTotalEarning = monetisationData?.showTotalEarning; //

	const router = useRouter ();

	const toggleFeedback = () => {
		if ( showStepperModal )
			toggleStepperModal ();
		setShowFeedback ( prev => !prev );
	};

	const onClickHandler = async ( { type } ) => {
		if ( isMigratingData ) {
			const data = getMigratedInitialMonetisationData ( { type } );

			setMonetisationData ( data );

			return;
		}
		const data =  await updateMonetisationData ( type );

		setMonetisationData ( data );
	};

	const tabs = [
		{
			title : "Live Streams",
			type  : "live"
		},
		{
			title : "Reels + Videos",
			type  : "reels"
		}
	];

	const handleOpenPage = () => {
		// handle webview params if they're present, would still work otherwise
		const params = createURLSearchParams ( router.query );

		router.push ( `earning${ params }` );
	};

	const toggleStepperModal = () => {
		setShowStepperModal ( prev => !prev );
	};

	const handleDetailedBtn = () => {

		const ctOptions = {
			eventProperty : `Earned_view_detailed_click_${ activeTab === "live" ? "Live" : "Static" }`,
			value         : true
		};

		storeCTEvent ( "creator_dashboard_navigation", ctOptions );

		// case - both of them true
		if ( showTotalEarning ) {
			handleOpenPage ();

			return;
		}

		switch ( activeTab ) {

			case "live": {

				if ( isLiveStreamMonetised ) {
					handleOpenPage ();

					return;
				} else
					toggleStepperModal ();

				break;
			}

			case "reels": {

				if ( isReelsMonetised ) {
					handleOpenPage ();

					return;
				} else
					toggleStepperModal ();

				break;

			}

			default:
				break;
		}

	};

	return (
		<Presentation
			activeTab           = { activeTab }
			handleDetailedBtn   = { handleDetailedBtn }
			isMigratingData     = { isMigratingData }
			isMobile            = { isMobile }
			monetisationData    = { monetisationData || intialMonetisationData }
			onClickHandler      = { onClickHandler }
			setActiveTab        = { setActiveTab }
			setMonetisationData = { setMonetisationData }
			showFeedback        = { showFeedback }
			showStepperModal    = { showStepperModal }
			showTotalEarning    = { showTotalEarning }
			tabs                = { tabs }
			toggleFeedback      = { toggleFeedback }
			toggleStepperModal  = { toggleStepperModal }
			{ ...props }
		/>
	);
};

export default component;

